import Header from '../../../pages/structure/Header/Header'
import * as React from 'react'
import ApiCall from '../../../components/ApiCall/ApiCall'
import { Alert, Card } from 'react-bootstrap'
import SettingsInterfacePassword from '../../../components/UserProfil/SettingsPassword/SettingsInterfacePassword'
import AccountParametersPassword from './AccountParameterPassword'
import img_sec_pass from './../../../Icone/undraw_security_pass.png'
import Footer from '../../../pages/structure/Footer/Footer'
require('../settings.css')

/*
	this class is the main file of the settings page "modification de mot de passe" for the password
*/
interface SettingsPasswordProps {
}

export default class Settings extends React.Component<SettingsPasswordProps, SettingsInterfacePassword> {

	private api = new ApiCall()

    constructor (props: SettingsPasswordProps) {
		super(props)
        this.state = {
            oldPassword: "",
			errorOldPassword: "",
			newPassword: "",
			errorNewPassword: "",
			confirmationPassword: "",
			errorConfirmationPassword: "",
			location: "",
            error: false,
            message: ""
        }
	}

    writeError() {
        let {error, message} = this.state

        if (error === true) {
            return (
                <>
                    <Alert variant="danger">
                        {message}
                    </Alert>
                </>
            );
        } else if (message !== "") {
            return (
                <>
                    <Alert variant="success">
                        {message}
                    </Alert>
                </>
            );
        }
	}
	
	submitNewPassword = async () => {
		let {oldPassword, newPassword, confirmationPassword} = this.state
		if(newPassword !== confirmationPassword)
		{
			this.setState({
				error: true,
				message: "Veuillez entrer le même mot de passe dans les deux champs."
			})
			return
		}

		const request = await this.api.ApiCall("passwords", "PATCH",
		{
			oldPassword: oldPassword,
			newPassword: newPassword
		}, localStorage.getItem('AccessToken'))
		console.log(request.status)

		if(request.status === 204)
		{
			this.setState({
                error: false,
                message: "Votre mot de passe a bien été modifié."
            })
		}
		else {
			this.setState({
                error: true,
                message: request.data.message
            })
		}
	}

    handleChange = (event: React.FormEvent<HTMLInputElement>, target: string) => {
		this.setState({
			[target]: (event.target as HTMLInputElement).value
		} as any);
	}

    render () {
		if (localStorage.getItem('AccessToken') === null) {
			return (
				<>
					<Header/>
					{ this.writeError() }
				</>
			);
		}
		return (
			<>
				<div id="other_canv">
					<div id="particles-js">
						<Header/>
						<div className="hero-wrap js-fullheight">
							<div className="overlay"></div>
							<div className="container">
								<div className="row no-gutters slider-text align-items-center justify-content-center" data-scrollax-parent="true">
									<div id="border-search" className="col-md-6 ftco-animate text-center fadeInUp ftco-animated" data-scrollax=" properties: { translateY: '70%' }">
										<br></br>
										<br></br>
										<h1 className="mb-3 bread" data-scrollax="properties: { translateY: '30%', opacity: 1.6 }">
											Modification de votre mot de passe
										</h1>
									</div>
								</div>
							</div>
						</div>
					</div>
				<section>
					<div className={"boddy-settings"}>
						<div  className={"title-settings"}>
							{ this.writeError() }
							<h3>Vous avez la possibilité de modifier votre mot de passe sur cette page</h3>
							<br/>
							<img alt="sec_pass" src={img_sec_pass} width="20%" height="20%"></img>
							<br/>
							<p>Nous vous conseillons de modifier celui-ci tous les mois pour garantir la sécurité de votre compte</p>
						</div>
						<div>
							<Card>
								<Card.Body>
									<div id="password_settings_container" className={"container"}>
										<AccountParametersPassword
											state={this.state}
											handleChange={this.handleChange}
											sbmitNewPassword={this.submitNewPassword}/>
									</div>
								</Card.Body>
							</Card>
						</div>
					</div>
				</section>
				<Footer></Footer>
				</div>
			</>
		);
    }
	
}